import isFirstBlock from './isFirstBlock';
export default function isFirstCharacter(editor) {
  return isFirstBlock(editor) && editor.value.selection.isCollapsed && editor.value.selection.start.offset === 0 && editor.value.document.getOffset(editor.value.selection.start.key) === 0;
}